import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCustomReports = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"data-id": "custom-reports-icon",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.57747 2.72835H5.00126C4.96869 2.85667 4.95182 2.98956 4.95182 3.12419C4.95182 3.55102 5.12138 3.96037 5.4232 4.26219L5.8946 3.79078L5.4232 4.26219C5.72501 4.564 6.13437 4.73356 6.5612 4.73356C6.98803 4.73356 7.39738 4.564 7.6992 4.26219L7.16887 3.73186L7.6992 4.26219C8.00101 3.96037 8.17057 3.55102 8.17057 3.12419C8.17057 2.98956 8.1537 2.85667 8.12114 2.72835H8.54492H10.5716C11.0458 2.72835 11.4409 3.06978 11.5242 3.52002H10.5716C8.57472 3.52002 6.95703 5.13771 6.95703 7.1346V16.1242H2.55078C2.0161 16.1242 1.58203 15.6901 1.58203 15.1554V3.6971C1.58203 3.16242 2.0161 2.72835 2.55078 2.72835H4.57747ZM9.60286 7.1346C9.60286 6.59992 10.0369 6.16585 10.5716 6.16585H15.0153C15.269 6.16585 15.5157 6.26797 15.6988 6.45107L18.1301 8.88238C18.3133 9.06548 18.4154 9.31217 18.4154 9.56592V17.4471C18.4154 17.9818 17.9813 18.4159 17.4466 18.4159H10.5716C10.0369 18.4159 9.60286 17.9818 9.60286 17.4471V7.1346Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgCustomReports;
